module.exports = "/work-site/img/monitor.43343663.png";